import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrVerificationStatus.ts
var t = () => e("verificationStatus");
//#endregion
export { t as useTrVerificationStatus };
